/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { map, Observable } from 'rxjs';
import { DialogService } from 'nebula-ui-kit';
import { inject, Injectable } from '@angular/core';
import { SelectDialogComponent } from '../../../select-dialog/select-dialog.component';
import { FormatoContableService, FormatoContableResponse } from './formato-contable.service';

export interface FormatoContableSelect {
  id: number;
  codigo: string;
  nombre: string;
  tipoOperacionConceptoId: number;
  tipoOperacionNombre: string;
  generaAsientoOrden?: string;
  status: string;
}

export interface FormatoContableFilters {
  tipoOperacionConceptoId?: number;
  status?: 'ACTIVE' | 'INACTIVE' | 'BLOCKED';
}

@Injectable({ providedIn: 'root' })
export class FormatoContableModalService {
  readonly dialogService = inject(DialogService);
  readonly formatoContableService = inject(FormatoContableService);

  openSelector(
    title: string,
    currentValue?: string,
    filters?: FormatoContableFilters,
  ): Observable<FormatoContableSelect | null> {
    const columns = [
      { key: 'codigo', label: 'Cod. Formato', sortable: true, width: '50%' },
      { key: 'nombre', label: 'Nombre Formato Contable', sortable: true, width: '50%' },
    ];

    const loadDataFn = async (
      params: any,
    ): Promise<{ data: FormatoContableSelect[]; total: number }> => {
      const page = params.page - 1;
      const size = params.limit || 10;
      const searchTerm = params.search || '';

      try {
        let formatos: FormatoContableResponse[] = [];

        if (filters?.tipoOperacionConceptoId) {
          formatos =
            (await this.formatoContableService
              .getActiveFormatsByOperation(filters.tipoOperacionConceptoId)
              .toPromise()) || [];
        } else {
          formatos = (await this.formatoContableService.getActiveFormats().toPromise()) || [];
        }

        let filteredFormatos = formatos;
        if (searchTerm) {
          const term = searchTerm.toLowerCase();
          filteredFormatos = formatos.filter(
            (f) => f.codigo.toLowerCase().includes(term) || f.nombre.toLowerCase().includes(term),
          );
        }

        if (filters?.status) {
          filteredFormatos = filteredFormatos.filter((f) => f.status === filters.status);
        }

        const start = page * size;
        const end = start + size;
        const paginatedData = filteredFormatos.slice(start, end);

        return {
          data: paginatedData.map((f) => ({
            id: f.id,
            codigo: f.codigo,
            nombre: f.nombre,
            tipoOperacionConceptoId: f.tipoOperacionConceptoId,
            tipoOperacionNombre: f.tipoOperacionNombre || '',
            generaAsientoOrden: f.generaAsientoOrden,
            status: f.status,
          })),
          total: filteredFormatos.length,
        };
      } catch (error) {
        return { data: [], total: 0 };
      }
    };

    const dialogRef = this.dialogService.open(SelectDialogComponent, {
      data: {
        title: title,
        columns: columns,
        multiSelect: false,
        searchPlaceholder: 'Buscar por código o nombre...',
        loadDataFn: loadDataFn,
        itemIdKey: 'id',
        displayKey: 'codigo',
        selectedItems: currentValue ? [{ codigo: currentValue, nombre: currentValue }] : [],
        pageSize: 10,
        pageSizeOptions: [10, 25, 50, 100],
      },
      size: 'lg',
      width: '800px',
    });

    return dialogRef
      .afterClosed()
      .pipe(
        map((selected: FormatoContableSelect[]) =>
          selected && selected.length > 0 ? selected[0] : null,
        ),
      );
  }
}
